import {
  applyPatch,
  walk,
  getType,
  getRoot,
  types as t,
  getEnv,
  resolveIdentifier,
  hasParent,
  getParent
} from '@invisr/mobx-state-tree'
import { toJS } from 'mobx'

const reference = (type, name) => {
  return t.maybeNull(
    t.reference(type, {
      get (id, parent) {
        try {
          const res = resolveIdentifier(type, parent, id)
          if(res) return res
        } catch (e) {}

        let root = getRoot(parent) as any
        let fn
        while (!fn && parent) {
          if (parent && typeof parent.getOrLoadObject === 'function') fn = parent.getOrLoadObject
          parent = hasParent(parent) ? getParent(parent) : null
        }
        if (!fn) {
          if (root.getOrLoadObject) fn = root.getOrLoadObject
          else if (getEnv(root)) fn = getEnv(root).getOrLoadObject
        }

        return fn && fn(name, id, parent)
      },
      set (value) {
        return value && value.id
      },
      onInvalidated: event => {
        if (event.cause === 'invalidSnapshotReference') return
        event.removeRef()
      }
    })
  )
}

export default reference

export const safeReference = type =>
  t.maybeNull(
    t.reference(type, {
      get (id, parent) {
        try {
          return resolveIdentifier(type, parent, id)
        } catch (e) {
          return null
        }
      },
      set (o) {
        console.log('SETTING REFERENCE', toJS(o))
        if (o && typeof o === 'object') return o.id
        return o
      },
      onInvalidated (event) {
        if (event.cause === 'invalidSnapshotReference') return
        event.parent && event.parent.del()
      }
    })
  )

export const clearReferences = (tree, id) => {
  walk(tree, node => {
    let nodeType = getType(node) as any
    // console.log(getType(node), node)
    if (nodeType.properties) {
      let refs = Object.keys(nodeType.properties).filter(
        k => nodeType.properties[k].name.indexOf('reference') !== -1
      )
      refs.map(key => {
        if (node[key] && node[key].id === id) {
          applyPatch(node, { op: 'replace', path: '/' + key, value: null })
        }
      })
    }
  })
}
